import { render, staticRenderFns } from "./giftfinder.vue?vue&type=template&id=02a74c44&scoped=true"
import script from "./giftfinder.vue?vue&type=script&lang=js"
export * from "./giftfinder.vue?vue&type=script&lang=js"
import style0 from "./giftfinder.vue?vue&type=style&index=0&id=02a74c44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a74c44",
  null
  
)

export default component.exports